exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.seckill_tabs[data-v-a60ae90e] {\n  padding: 12px;\n}\n", ""]);

// exports
